import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=264f1927&scoped=true&"
import script from "./LatestNews.vue?vue&type=script&lang=js&"
export * from "./LatestNews.vue?vue&type=script&lang=js&"
import style0 from "./LatestNews.vue?vue&type=style&index=0&id=264f1927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f1927",
  null
  
)

export default component.exports